export const baseUrl = process.env.REACT_APP_BASE_URL;

export const GetRequest = async (
  url,
  urlParameter1 = null,
  urlParameter2 = null,
  haveJson = true
) => {
  let finalUrl = `${baseUrl}${url}`;
  if (urlParameter1) finalUrl += `/${urlParameter1}`;
  if (urlParameter2) finalUrl += `/${urlParameter2}`;

  const response = await fetch(finalUrl, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });

  if (!response.ok) {
    const errorMessage = await response.text();
    throw new Error(errorMessage);
  }

  if (!haveJson) {
    return response;
  }

  const data = await response.json();
  return data;
};

export const PostRequest = async (
  url,
  body,
  urlParameter1 = null,
  urlParameter2 = null,
  ContentType = "application/json"
) => {
  let finalUrl = `${baseUrl}${url}`;
  if (urlParameter1) finalUrl += `/${urlParameter1}`;
  if (urlParameter2) finalUrl += `/${urlParameter2}`;

  const headers = {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  };

  if (ContentType !== "multipart/form-data") {
    headers["Content-Type"] = ContentType;
  }

  const response = await fetch(finalUrl, {
    method: "POST",
    headers: headers,
    body: ContentType === "application/json" ? JSON.stringify(body) : body,
  });

  if (!response.ok) {
    const errorMessage = await response.text();
    throw new Error(errorMessage || "Network response was not ok.");
  }

  return response;
};

export const PutRequest = async (
  url,
  body,
  urlParameter = null,
  ContentType = "application/json"
) => {
  const finalUrl = urlParameter
    ? `${baseUrl}${url}/${urlParameter}`
    : `${baseUrl}${url}`;

  const headers = {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  };

  if (ContentType !== "multipart/form-data") {
    headers["Content-Type"] = ContentType;
  }

  const response = await fetch(finalUrl, {
    method: "PUT",
    headers: headers,
    body: ContentType === "application/json" ? JSON.stringify(body) : body,
  });

  if (!response.ok) {
    const errorMessage = await response.text();
    throw new Error(errorMessage || "Network response was not ok.");
  }

  return response;
};

export const DeleteRequest = async (url, urlParameter) => {
  const finalUrl = `${baseUrl}${url}/${urlParameter}`;

  const response = await fetch(finalUrl, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });

  if (!response.ok) {
    const errorMessage = await response.text();
    throw new Error(errorMessage);
  }

  return response;
};
